module.exports = __webpack_public_path__ + "img/mrxweb.7e355d5d.svg";